module.exports = new __parcel__URL__("menu-add-selfie.549ecfab.svg").toString();